import React, { memo } from "react";
import PropTypes from "prop-types";
import { DhlDropdown } from "@dhl-official/react-library";
import { LanguageSelectorWrapper } from "./styled";

const LABELS = {
  "en-AU": "Australia - EN",
  "en-US": "United States - EN",
  "en-IT": "Italy - EN",
  "it-IT": "Italy - IT",
  "en-IN": "India - EN",
  "en-MX": "Mexico - EN",
  "es-MX": "Mexico - ES",
  "en-GB": "Great Britain - EN",
};

const LanguageSelector = ({ onChange, selectedLocale, locales }) => {
  const data = locales.map((locale) => ({
    label: LABELS[locale],
    value: locale,
  }));

  return (
    <LanguageSelectorWrapper className="LanguageSelectorWrapper">
      <DhlDropdown
        id="localeSelector"
        label="Locale Selector"
        changeEvent={onChange}
        name="localeSelector"
        value={selectedLocale}
        data={data}
        dataTestid="locale-selector"
      />
    </LanguageSelectorWrapper>
  );
};

LanguageSelector.propTypes = {
  onChange: PropTypes.func.isRequired,
  locales: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedLocale: PropTypes.string.isRequired,
};

export default memo(LanguageSelector);
